export default "__VITE_ASSET__BhoyVJPk__"